
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/companies/[displayname]/jobs",
      function () {
        return require("private-next-pages/companies/[displayname]/jobs/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/companies/[displayname]/jobs"])
      });
    }
  